import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { StatusPill } from "@/components/shared/Common";

export default function AdminBookings() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/bookings/mine").then((r) => setItems(r.data || [])).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-outfit font-bold text-white">All Bookings</h1>
      {items.length === 0 && <div className="card-flat p-8 text-center text-white/60 font-manrope">No bookings yet.</div>}
      <div className="grid gap-3">
        {items.map((b) => (
          <div key={b.id} className="card-flat p-5" data-testid={`admin-booking-${b.id}`}>
            <div className="flex justify-between items-start gap-3">
              <div>
                <div className="font-outfit font-semibold text-white">{b.company_name}</div>
                <div className="text-sm text-white/60 font-manrope">{b.date || "—"} · {b.workers}× · {b.hours}h @ €{b.hourly_rate}/hr</div>
                <div className="text-sm text-white/60 font-manrope">Fee: €{b.fee?.applied_fee} ({b.fee?.fee_method})</div>
              </div>
              <div className="flex flex-col gap-2 items-end">
                <StatusPill status={b.status} />
                <span className="text-xs font-manrope text-white/60">{b.payment_status}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
